import {
  Document,
  DocumentAttributes,
  Section,
  ItemSet,
  DocumentTokenInformation,
  ReferenceFileInformation,
  UnmanagedDocument,
  IBookmark,
} from "../../../documaker/domain/document";
import { PatientProfileInformation } from "../../../base/domain/patient";
import { FormatReference } from "../../../documaker/domain/format";
import { HisInformation } from "../../../base/domain/his";
import { DesignatedDoctorInformation } from "../../../base/domain/user";
import { InstitutionItem } from "../../../base/domain/institution";
import { ReferenceFileContentSource } from ".";

export class EditableFormatDocument extends Document {
  constructor(
    documentId: number,
    edition: number,
    attributes: DocumentAttributes,
    itemSets: ItemSet[],
    sections: Section[],
    extraFormats: FormatReference[],
    hisInformation: HisInformation,
    referenceFiles: ReferenceFileInformation[],
    patientProfile: PatientProfileInformation,
    designatedDoctorInformations: DesignatedDoctorInformation[],
    isNewHisInformationApplied: boolean,
    editToken: DocumentTokenInformation,
    createToken: DocumentTokenInformation,
    writeToken: DocumentTokenInformation,
    selectedInstitution: InstitutionItem,
    unmanagedInformation: UnmanagedDocument,
    public referenceFileContentSource: ReferenceFileContentSource[],
    bookmarks: IBookmark[],
  ) {
    super(
        documentId,
        edition,
        attributes,
        itemSets,
        sections,
        extraFormats,
        hisInformation,
        referenceFiles,
        patientProfile,
        designatedDoctorInformations,
        isNewHisInformationApplied,
        editToken,
        createToken,
        writeToken,
        selectedInstitution,
        unmanagedInformation,
        bookmarks,
        // フォーマット編集は連鎖文書に対応しない.
        [],
        [],
        [],
        [],
        false,
        null,
    );
  }

  clone() {
    return new EditableFormatDocument(
      this.documentId,
      this.edition,
      this.attributes,
      this.itemSets,
      this.sections,
      this.extraFormats,
      this.hisInformation,
      this.referenceFiles,
      this.patientProfile,
      this.designatedDoctorInformations,
      this.isNewHisInformationApplied,
      this.editToken,
      this.createToken,
      this.writeToken,
      this.selectedInstitution,
      this.unmanagedInformation,
      this.referenceFileContentSource,
      this.bookmarks,
    );
  }
}
